import { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { SpinningLogo, Loading } from "../components";

export const VisualPopup = ({
  isIntroPage,
  isMobile,
  isVisible,
  config,
  project,
}) => {
  const [loading, setLoading] = useState(true);
  const [isActive, setIsActive] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    if (isVisible) {
      // Start fade-in animation
      setFadeOut(true);
      setTimeout(() => setIsActive(true), 500);
    } else {
      // Start fade-out animation
      setIsActive(false);
      setTimeout(() => setFadeOut(false), 500); // Matches animation duration
    }
  }, [isVisible]);

  if (!fadeOut) return null; // Prevent rendering until animation starts

  if (isIntroPage) {
    return null;
  }

  const handleCanPlayThrough = () => {
    setLoading(false); // Когда видео готово к воспроизведению, меняем состояние загрузки
  };

  const className = "logos-visual-popup";

  return (
    <div className={`visual-popup ${isActive ? "show" : ""}`}>
      {loading && <Loading />}

      <div className={`popup-content ${isActive ? "open" : "closed"}`}>
        <video
          // preload="none"
          preload="metadata"
          autoPlay
          loop
          muted
          className={`fade-in-video ${isActive ? "active" : ""}`}
          playsInline // Этот атрибут предотвращает открытие видео в плеере на мобильных устройствах
          onCanPlayThrough={handleCanPlayThrough} // Используем onCanPlayThrough
          style={loading ? { visibility: "hidden" } : {}}
        >
          <source src={`/assets/visuals_${project}.mp4`} type="video/mp4" />
        </video>
        <NavLink
          to={config?.path}
          className={`slide-up ${isActive ? "active" : ""}`}
        >
          <SpinningLogo className={className} logos={config?.logos} />
        </NavLink>
      </div>
    </div>
  );
};
